import { gql } from 'apollo-angular';

export const RemoveFunnelDocument = gql`
  mutation removeFunnel($funnelId: Int!) {
    removeFunnel(funnelId: $funnelId)
  }
`;
